import { render, staticRenderFns } from "./SettingsBottomNav.vue?vue&type=template&id=10adf632&scoped=true&"
import script from "./SettingsBottomNav.vue?vue&type=script&lang=js&"
export * from "./SettingsBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBottomNav.vue?vue&type=style&index=0&id=10adf632&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10adf632",
  null
  
)

export default component.exports